export const defaultCourseProgress = {
  currentModule: 0,
  currentLesson: 0,
  modules: []
}



// WEBPACK FOOTER //
// ./src/store/data/defaultCourseProgress.js